import { Box, Card, Text, TogglerCheckbox } from '@factorialco/deprecated-design-system'

import { useFormContext } from 'modules/core/hooks/useForm'

import { WorkingConditionDisplayItemProps } from 'modules/contracts_settings/lib/useWorkConditionItemsCategories'
import { getI18nItemFieldKey } from 'modules/contracts_settings/lib/useWorkConditionItemsCategories'
import { WorkConditionVersionItemsFormData } from 'modules/contracts_settings/pages/WorkingConditionsVersionPage/forms'

const WorkingConditionItemToogler = ({ name }: WorkingConditionDisplayItemProps) => {
  const fieldLabelKey = getI18nItemFieldKey(name, 'label')
  const fieldDescriptionKey = getI18nItemFieldKey(name, 'description')

  const form = useFormContext<WorkConditionVersionItemsFormData>()

  return (
    <Card>
      <Card.Content>
        <Box justifyContent="spaceBetween" flexDirection="row" width="full">
          <Text.Normal weight="semibold">{fieldLabelKey}</Text.Normal>
          <TogglerCheckbox
            value={Boolean(form.values.items[name])}
            onChange={(newValue) => form.setFieldValue('items.' + name, newValue)}
          />
        </Box>
        <Text.Normal>{fieldDescriptionKey}</Text.Normal>
      </Card.Content>
    </Card>
  )
}

export default WorkingConditionItemToogler
